var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGvard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 70,
    viewBox: "0 0 59 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.926 18.0179C58.8422 16.1764 58.8422 14.4185 58.8422 12.6607C58.8422 11.2377 57.7524 10.1495 56.3273 10.1495C45.8484 10.1495 37.8845 7.13602 31.2618 0.690583C30.2558 -0.230194 28.7469 -0.230194 27.7409 0.690583C21.1183 7.13602 13.1543 10.1495 2.67546 10.1495C1.25033 10.1495 0.160533 11.2377 0.160533 12.6607C0.160533 14.4185 0.160532 16.1764 0.0767015 18.0179C-0.258622 35.5964 -0.761609 59.704 28.663 69.8326L29.5014 70L30.3397 69.8326C59.6805 59.704 59.2613 35.6801 58.926 18.0179ZM27.4894 42.3767C26.9864 42.7952 26.3996 43.0463 25.729 43.0463H25.6451C24.9745 43.0463 24.3038 42.7115 23.8847 42.2093L16.0884 33.5874L19.8608 30.2392L25.9805 37.0194L39.5611 24.1285L42.9981 27.8117L27.4894 42.3767Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGvard);
export default __webpack_public_path__ + "static/media/gvard.6ed244dd15187ef930bec19a7dfa4b30.svg";
export { ForwardRef as ReactComponent };